<template>
    <div
        class="apprentice-simple-card"
        id="portfolio-answers-download-files">

        <h5 class="title">{{ $t('portfolio.answers.download') }}</h5>
        <p class="banner-uplaod-info text-muted">
            {{ $t('portfolio.answers.download.explanation') }}<br />
        </p>

        <b-button
            class="btn-download btn-add-file"
            @click="download"
            variant="primary">
            {{ $t('common.download') }}
        </b-button>
    </div>
</template>

<script>
export default {
    name: 'design-2021-portfolio-answers-download-files',
    props: {
        groupIn: Object,
    },
    methods: {
        download() {
            this.alert.loading(this.$t('portfolio.answer.download.loading.title'), this.$t('portfolio.answer.download.loading.description'));

            this.axios.get(this.routes.portfolioDownloadAnswers(this.groupIn.id), {responseType: 'blob'})
                .then((response) => {
                    // create file link in browser's memory
                    const href = URL.createObjectURL(response.data);

                    // create "a" HTML element with href to file & click
                    const link = document.createElement('a');
                    link.href = href;
                    link.setAttribute('download', `${this.groupIn.slug}.zip`); //or any other extension
                    document.body.appendChild(link);
                    link.click();

                    // clean up "a" element & remove ObjectURL
                    document.body.removeChild(link);
                    URL.revokeObjectURL(href);
                    this.alert.success();
                },
                (error) => {
                    this.alert.warning(this.$t('portfolio.answer.download.warning.no.files.uploaded.title'), this.$t('portfolio.answer.download.warning.no.files.uploaded.description'));
                },
            );
        }
    },
};
</script>

<style scoped lang="scss"></style>
